import { customElement, property } from 'lit/decorators.js';
import { CSSResult, html, LitElement, PropertyValues, unsafeCSS } from 'lit';
import { consume } from '@lit/context';
import css from './wishlist-brand-remove-button.scss?inline';
import { i18nContext } from '../../../scripts/context/i18nContext.js';
import { Messages, WishlistBrandListItem } from '../../../@types/wishlist.js';
import { renderHeartIcon } from '../heart-button/heart-icons.js';
import { formatBrandUnfollowedAriaLabel, unfollowBrand } from '../wishlist-brands/wishlist-brands-actions.js';

@customElement('ents-wishlist-brand-remove-button')
export class WishlistBrandRemoveButtonElement extends LitElement {
  @consume({ context: i18nContext })
  private messages!: Messages;

  @property({ type: Object, attribute: 'brand' })
  private brand!: WishlistBrandListItem;

  static get styles(): CSSResult {
    return unsafeCSS(css);
  }

  private handleClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    unfollowBrand(this.messages, this.brand);
  }

  protected render() {
    return html`
      <button
        @click="${this.handleClick}"
        type="button"
        aria-label="${formatBrandUnfollowedAriaLabel(this.messages, this.brand.name)}"
        data-test-ents-wishlist-brand-unfollow="${this.brand.code}"
      >
        ${renderHeartIcon('large', true)}
      </button>
    `;
  }

  shouldUpdate(changedProperties: PropertyValues): boolean {
    if (changedProperties.size === 0) {
      return false;
    }
    return super.shouldUpdate(changedProperties);
  }
}
